(function() {
  'use strict';
  
  angular.module('app.validators', [
    
  ])
  
})();